export default __webpack_public_path__ + "static/sky-345b993b3b555dc84792fdb78a4a1a5c.webp";